/*
  Volume Discount Selector – PDP
  Kachel-UI auf der Produktseite: Preisberechnung, Mengensteuerung,
  Variantenwechsel und Pflege des Hidden Inputs properties[_vd_tiers].

  Wird ausschließlich über sections/main-product.liquid geladen (alle
  product.*-Templates). Die Property-Injektion für Fremd-Endpoints
  (Wishlist, OpenSearch-Suche) übernimmt volume-discount-selector-injector.js.
*/
(function () {
  'use strict';

  if (window._vdSelectorPdpLoaded) return;
  window._vdSelectorPdpLoaded = true;

  // Wie Shopify (und damit Warenkorb/Checkout): Der Prozentrabatt der Shopify
  // Function wird pro Stück berechnet und auf volle Cent abgerundet.
  // Bsp.: 7,50 € × 2 bei 5 % → 0,375 € → 0,37 € je Stück → 14,26 € (nicht 14,25 €).
  function calcUnitDiscount(priceInCents, discountPercent) {
    return Math.floor(priceInCents * discountPercent / 100);
  }

  function calcDiscountedUnitPrice(priceInCents, qty, discountPercent) {
    return priceInCents - calcUnitDiscount(priceInCents, discountPercent);
  }

  function formatMoney(cents) {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2
    }).format(cents / 100);
  }

  function formatUnitPrice(cents, refValue, refUnit) {
    var formatted = new Intl.NumberFormat('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(cents / 100);
    var ref = refValue && refValue != 1 ? refValue + ' ' : '';
    return formatted + ' \u20AC/' + ref + refUnit;
  }

  // Das Snippet rendert das Hidden Input im variant_picker-Block, also
  // außerhalb des Add-to-Cart-Formulars – hier wird es hineinverschoben.
  function moveTiersInputIntoForm() {
    var input = document.querySelector('[data-vd-tiers-input]');
    if (!input) return;
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    if (!form.contains(input)) {
      form.appendChild(input);
    }
  }

  function parseTiersString(tiersString) {
    if (!tiersString || tiersString.trim() === '') return [];
    try {
      return tiersString.trim().split('|').map(function (part) {
        var segments = part.trim().split('-');
        return {
          qty: parseInt(segments[0], 10),
          discount: parseInt(segments[1], 10)
        };
      }).filter(function (t) {
        return !isNaN(t.qty) && !isNaN(t.discount);
      });
    } catch (e) {
      return [];
    }
  }

  function buildTilesHTML(tiers, hasUnitPrice) {
    return tiers.map(function (tier, i) {
      return '<button' +
        ' class="volume-discount-selector__tile' + (i === 0 ? ' is-active' : '') + '"' +
        ' data-qty="' + tier.qty + '"' +
        ' data-discount="' + tier.discount + '"' +
        ' type="button"' +
        ' aria-pressed="' + (i === 0 ? 'true' : 'false') + '"' +
        '>' +
        (tier.discount > 0 ? '<span class="volume-discount-selector__badge">-' + tier.discount + '%</span>' : '') +
        '<span class="volume-discount-selector__qty">' + tier.qty + '\u00d7</span>' +
        '<span class="volume-discount-selector__price" data-tier-price>\u2014</span>' +
        (hasUnitPrice ? '<span class="volume-discount-selector__unit-price" data-tier-unit-price>\u2014</span>' : '') +
        '</button>';
    }).join('');
  }

  function initSelector(container, skipMainPrice) {
    if (container._vdInitialized) return;
    container._vdInitialized = true;

    var variantDataEl = container.querySelector('[data-vd-variant-data]');
    var vd = variantDataEl ? JSON.parse(variantDataEl.textContent) : {};
    var variantPrice = vd.variantPrice || 0;
    var unitPrice = vd.unitPrice != null ? vd.unitPrice : null;
    var unitPriceRef = vd.unitPriceRef || 1;
    var unitPriceUnit = vd.unitPriceUnit || '';
    var variantId = vd.variantId || '';
    var variantTitle = vd.variantTitle || '';

    var productId = container.dataset.productId;
    var productTitle = container.dataset.productTitle || '';
    var perItemLabel = container.dataset.perItemLabel || '/ Stk.';
    var gtmEnabled = container.dataset.gtmEnabled !== 'false';
    var gtmEventName = container.dataset.gtmEventName || 'volume_discount_selected';

    var tiles = container.querySelectorAll('.volume-discount-selector__tile');
    if (!tiles.length) return;

    function updateTilePrices(price, uPrice) {
      tiles.forEach(function (tile) {
        var qty = parseInt(tile.dataset.qty, 10);
        var discount = parseFloat(tile.dataset.discount) || 0;
        var discountedUnit = calcDiscountedUnitPrice(price, qty, discount);
        var priceEl = tile.querySelector('[data-tier-price]');
        if (priceEl) priceEl.textContent = formatMoney(discountedUnit) + ' ' + perItemLabel;
        var unitPriceEl = tile.querySelector('[data-tier-unit-price]');
        if (unitPriceEl && uPrice) {
          var discountedUnitPricePer = Math.round(uPrice * (1 - discount / 100));
          unitPriceEl.textContent = formatUnitPrice(discountedUnitPricePer, unitPriceRef, unitPriceUnit);
        }
      });
    }

    function findQuantityInput() {
      var section = container.closest('.shopify-section');
      if (!section) section = document;
      return section.querySelector('input[name="quantity"]');
    }

    function findPriceBlocks() {
      var section = container.closest('.shopify-section');
      if (!section) section = document;
      return {
        compact: section.querySelector('[data-update-block="price-compact"]'),
        extended: section.querySelector('[data-update-block="price-extended"]')
      };
    }

    function calcLineTotal(priceInCents, qty, discountPercent) {
      return calcDiscountedUnitPrice(priceInCents, qty, discountPercent) * qty;
    }

    function updateMainPrice(lineTotal, discount) {
      var blocks = findPriceBlocks();
      var targets = [blocks.compact, blocks.extended].filter(Boolean);
      targets.forEach(function (block) {
        var currentPrice = block.querySelector('.theme-current-price');
        if (currentPrice) {
          var visHidden = currentPrice.querySelector('.visually-hidden');
          var label = visHidden ? visHidden.outerHTML : '';
          currentPrice.innerHTML = label + formatMoney(lineTotal);
        }
        if (unitPrice) {
          var unitEl = block.querySelector('.product-price--unit');
          if (unitEl) {
            var discountedUnitPricePer = Math.round(unitPrice * (1 - discount / 100));
            var visHiddenUnit = unitEl.querySelector('.visually-hidden');
            var unitLabel = visHiddenUnit ? visHiddenUnit.outerHTML : '';
            var refDisplay = unitPriceRef != 1 ? unitPriceRef : '';
            unitEl.innerHTML = unitLabel + formatMoney(discountedUnitPricePer) + ' / ' + refDisplay + unitPriceUnit;
          }
        }
      });
    }

    function selectTile(tile) {
      tiles.forEach(function (t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-pressed', 'false');
      });
      tile.classList.add('is-active');
      tile.setAttribute('aria-pressed', 'true');

      var qty = parseInt(tile.dataset.qty, 10);
      var discount = parseFloat(tile.dataset.discount) || 0;
      var discountedUnit = calcDiscountedUnitPrice(variantPrice, qty, discount);
      var lineTotal = calcLineTotal(variantPrice, qty, discount);

      var qtyInput = findQuantityInput();
      if (qtyInput) {
        qtyInput.value = qty;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      updateMainPrice(lineTotal, discount);

      if (gtmEnabled) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: gtmEventName,
          discount_percent: discount,
          qty: qty,
          product_id: productId,
          variant_id: variantId,
          product_title: productTitle,
          variant_title: variantTitle,
          discounted_unit_price: Math.round(discountedUnit),
          line_total: lineTotal,
          currency: 'EUR'
        });
      }
    }

    // tiles neu referenzieren nach potenziellem grid.innerHTML rebuild
    tiles = container.querySelectorAll('.volume-discount-selector__tile');

    tiles.forEach(function (tile) {
      tile.addEventListener('click', function () { selectTile(tile); });
    });

    updateTilePrices(variantPrice, unitPrice);

    var activeTile = container.querySelector('.volume-discount-selector__tile.is-active');
    if (activeTile && !skipMainPrice) {
      var activeDiscount = parseFloat(activeTile.dataset.discount) || 0;
      var activeQty = parseInt(activeTile.dataset.qty, 10);
      var activeLineTotal = calcLineTotal(variantPrice, activeQty, activeDiscount);
      updateMainPrice(activeLineTotal, activeDiscount);
      var qtyInput = findQuantityInput();
      if (qtyInput) qtyInput.value = activeQty;
    } else if (activeTile && skipMainPrice) {
      var activeQty = parseInt(activeTile.dataset.qty, 10);
      var qtyInput = findQuantityInput();
      if (qtyInput) qtyInput.value = activeQty;
    }
  }

  function setupVariantChangeListener() {
    var productVariants = document.querySelector('product-variants[data-main-product-variants]');
    if (!productVariants) return;

    productVariants.addEventListener('VARIANT_CHANGE', function () {
      setTimeout(function () {
        var variantInput = document.querySelector('product-form input[name="id"], form[action*="/cart/add"] input[name="id"]');
        var currentVariantId = variantInput ? String(variantInput.value) : null;
        if (!currentVariantId) return;

        var mapEl = document.querySelector('[id^="vd-variants-map-"]');
        var variantsMap = {};
        if (mapEl) {
          try { variantsMap = JSON.parse(mapEl.textContent); } catch (e) {}
        }

        var variantData = variantsMap[currentVariantId];
        var selector = document.querySelector('[data-volume-discount]');

        if (!variantData || !variantData.tiers || variantData.tiers.trim() === '') {
          if (selector) selector.style.display = 'none';
          var tiersInput = document.querySelector('[data-vd-tiers-input]');
          if (tiersInput) {
            tiersInput.value = '';
            tiersInput.disabled = true;
          }
          var qtyInput = document.querySelector('input[name="quantity"]');
          if (qtyInput) qtyInput.value = 1;
          return;
        }

        if (selector) selector.style.display = '';

        var tiersInput = document.querySelector('[data-vd-tiers-input]');
        if (tiersInput) {
          tiersInput.value = variantData.tiers;
          tiersInput.disabled = false;
        }

        var variantDataEl = selector ? selector.querySelector('[data-vd-variant-data]') : null;
        if (variantDataEl) {
          variantDataEl.textContent = JSON.stringify({
            variantPrice: variantData.price,
            unitPrice: variantData.unitPrice,
            unitPriceRef: variantData.unitPriceRef,
            unitPriceUnit: variantData.unitPriceUnit,
            variantId: parseInt(currentVariantId, 10),
            variantTitle: variantData.variantTitle
          });
        }

        // Tiles neu generieren mit korrekten qty/discount Werten aus der Map
        if (selector) {
          var grid = selector.querySelector('.volume-discount-selector__grid');
          var parsedTiers = parseTiersString(variantData.tiers);
          if (grid && parsedTiers.length) {
            grid.innerHTML = buildTilesHTML(parsedTiers, !!variantData.unitPrice);
          }
          selector._vdInitialized = false;
          initSelector(selector, false);
        }

        moveTiersInputIntoForm();
      }, 50);
    });
  }

  function initAll() {
    moveTiersInputIntoForm();
    document.querySelectorAll('[data-volume-discount]').forEach(function (el) {
      initSelector(el);
    });
    setupVariantChangeListener();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
